import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { Fragment } from 'react';
import { Row } from 'react-bootstrap';
import CircledIcon from '../../../components/CircledIcon';
import Radio, { RadioGroup } from '../../../components/Radio';

const ComunicationsTabContent = () => {
  const preferredMethodsData = [
    {
      id: 'pm',
      name: 'statements-and--required-plan-info',
      title: 'Statements & Required Plan information',
      description:
        'An email notification, containing a link to your Savings Plan statement will be sent to the email address indicated each time a new statement is available.  To request a free paper copy by mail, go to Contact Us. ',
      methods: [
        { name: 'Email', value: 'email' },
        { name: 'Mail', value: 'mail' },
      ],
    },
    {
      id: 'trns',
      name: 'transaction',
      title: 'Transactions',
      description:
        'Savings account monthly Statements and Notifications anytime you complete a transaction for savings, pension or health.',
      methods: [
        { name: 'Email', value: 'email' },
        { name: 'Mail', value: 'mail' },
        { name: 'Text', value: 'text' },
      ],
    },
    {
      id: 'ntf',
      name: 'notifications',
      title: 'Notifications',
      description:
        'Benefits notices, Contact Us responses, Auto-Increase, Payment/Bill statements, new web features, etc.',
      methods: [
        { name: 'Email', value: 'email' },
        { name: 'Mail', value: 'mail' },
        { name: 'Text', value: 'text' },
      ],
    },
    {
      id: 'pi',
      name: 'plan-information',
      title: 'Required Plan Information',
      description:
        'Plan information, Notices, Summary Plan Descriptions, Summary Material Modifications and other plan information required by the Employee Retirement Security Act of 1974 (ERISA).',
      methods: [
        { name: 'Email', value: 'email' },
        { name: 'Mail', value: 'mail' },
        { name: 'Text', value: 'text' },
      ],
    },
  ];

  const [pm, setPm] = React.useState<string | number>('email-pm');
  const handlePmChange = (e: string | number) => {
    setPm(e);
  };
  const [trns, setTrns] = React.useState<string | number>('mail-trns');
  const handleTrnsChange = (e: string | number) => {
    setTrns(e);
  };
  const [ntf, setNtf] = React.useState<string | number>('text-ntf');
  const handleNtfChange = (e: string | number) => {
    setNtf(e);
  };

  const [pi, setPi] = React.useState<string | number>('email-pi');
  const handlePiChange = (e: string | number) => {
    setPi(e);
  };

  const getHandlerById = (value: string | number, event: any) => {
    switch (value) {
      case 'pm': {
        return handlePmChange(event);
      }
      case 'trns': {
        return handleTrnsChange(event);
      }
      case 'ntf': {
        return handleNtfChange(event);
      }
      case 'pi': {
        return handlePiChange(event);
      }
    }
  };

  const getStateValueById = (value: string | number) => {
    switch (value) {
      case 'pm': {
        return pm;
      }
      case 'trns': {
        return trns;
      }
      case 'ntf': {
        return ntf;
      }
      case 'pi': {
        return pi;
      }
    }
  };

  return (
    <Fragment>
      <section className={'w-100 d-flex justify-content-between mt-7'}>
        <div className={'d-flex align-items-center'}>
          <CircledIcon variant={'icon-emphasized'} icon={light('bullhorn')} />
          <h4 className={'ms-7 mb-0 text-sm-20-lg-32'}>Communications</h4>
        </div>
      </section>
      <Row className={'mt-10 mt-lg-13'}>
        <div className={'text-sm-14-lg-20 text-ligther-grey'}>
          Select your preferred method of delivery for each form of
          communcation.
        </div>
        <div>
          {preferredMethodsData.map((data, index) => {
            return (
              <Fragment key={index}>
                <div
                  className={
                    'd-flex justify-content-between mt-11 flex-column flex-lg-row'
                  }
                >
                  <div style={{ maxWidth: '510px' }}>
                    <h6 className="text-fs-6 fw-normal">{data.title}</h6>
                    <div className="text-ligther-grey text-caption mt-3 fw-light">
                      {data.description}
                    </div>
                  </div>
                  <div className={'d-flex align-items-start mt-7 mt-lg-0'}>
                    <RadioGroup
                      value={getStateValueById(data.id)}
                      name={data.name}
                      onChange={(e) => getHandlerById(data.id, e)}
                    >
                      <>
                        {data.methods.map((method, index) => {
                          return (
                            <Radio
                              id={`${data.id}-${index}`}
                              value={`${method.value}-${data.id}`}
                              label={method.name}
                              isRadioButton
                              className={'ms-lg-3 me-3 me-lg-0'}
                              key={index}
                            />
                          );
                        })}
                      </>
                    </RadioGroup>
                  </div>
                </div>
              </Fragment>
            );
          })}
        </div>
      </Row>
    </Fragment>
  );
};

export default ComunicationsTabContent;
